<template>
    <div id="parent-information">
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="8" v-if="item.hasOwnProperty('rulesOfResidence')">
                        <v-text-field v-model="item.rulesOfResidence.agreement" readonly hide-details
                            label="Version of Rules of Residence Signed" placeholder="Not Signed">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="8" v-else>
                        Applied before Rules of Residence Update
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-rules-of-residence',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
}
</script>